import {useAiChat} from '@/pages/MainPage/panes/Ai/useAi.mjs'

function replaceFormilyJson(template, jsonData) {
  // 如果jsonData是对象，转换为JSON字符串
  const jsonString = typeof jsonData === 'object' 
    ? JSON.stringify(jsonData, null, 2) 
    : jsonData;
  
  // 替换占位符
  return template.replace(/#\{#WF_SIMPLIFIED\}/g, jsonString);
}

export default ({wfMap, ...options}) => {
    const _ai = useAiChat(options)

    return {
        ..._ai,

        _getSystemMessage(template) {
            return replaceFormilyJson(template, wfMap)
        }
    }
}
